import { render, staticRenderFns } from "./LoyaltyBonusTypeAddComponent.vue?vue&type=template&id=57af4e26&scoped=true"
import script from "./LoyaltyBonusTypeAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyBonusTypeAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af4e26",
  null
  
)

export default component.exports